module.exports = __webpack_public_path__ + "static/media/surgical2.ec1138ba.jpg";